export const EVENT_TYPES = [
  "Mariage",
  "Anniversaire",
  "Entreprise",
  "Baptême / communion",
  "Association",
  "Autre",
];

export const STATUSES = [
  "Nouvelle demande internet",
  "Demande",
  "Option",
  "Confirmée",
  "Livrée",
  "Terminée",
  "Annulée",
];

export const STATUS_STYLES = {
  "Nouvelle demande internet": { cls: "bg-cyan-50 text-cyan-700 border-cyan-200", dot: "bg-cyan-500" },
  "Demande": { cls: "bg-purple-50 text-purple-700 border-purple-200", dot: "bg-purple-500" },
  "Option": { cls: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  "Confirmée": { cls: "bg-emerald-50 text-emerald-800 border-emerald-200", dot: "bg-emerald-500" },
  "Livrée": { cls: "bg-blue-50 text-blue-800 border-blue-200", dot: "bg-blue-500" },
  "Terminée": { cls: "bg-slate-100 text-slate-700 border-slate-300", dot: "bg-slate-400" },
  "Annulée": { cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
};

export const fmtEUR = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(n || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso + (iso.length === 10 ? "T00:00:00" : ""));
  const s = new Intl.DateTimeFormat("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" }).format(d);
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const fmtDT = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  const s = new Intl.DateTimeFormat("fr-FR", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" }).format(d);
  return s.charAt(0).toUpperCase() + s.slice(1);
};
